import { defineComponent, createApp, reactive } from 'vue';

import { fetcher, FetchResult } from '@/common/fetcher';
import { WorkspaceType } from '@/common/interfaces';
import { useWorkspaceStore } from '@/workspace/workspaceStore';

declare module '@vue/runtime-core' {
	interface ComponentCustomProperties {
		$workspace: {
			info: WorkspaceType;
		}
	}
}

class WorkspacePluginClass {
	info = null as WorkspaceType | null;
	loaded = false;

	created() {
		const workspaceInitial = document.getElementById('workspace-initial');

		if (workspaceInitial !== null && workspaceInitial.textContent!) {
			const data = JSON.parse(workspaceInitial.textContent!) as WorkspaceType;
			if (data) {
				this.info = data;
				this.loaded = true;
				const store = useWorkspaceStore();
				store.setWorkspace(this.info);
			}
		} else {
			this.reloadWorkspace();
		}
	}

	workspaceLoaded(result: FetchResult): void {
		if (result.response.ok && result.json.success) {
			this.info =	result.json.data as WorkspaceType;
			const store = useWorkspaceStore();
			store.setWorkspace(this.info);
		}
		this.loaded = true;
	}

	async reloadWorkspace(): Promise<WorkspaceType | null> {
		await fetcher.Get('/api/workspace/')
			.then(this.workspaceLoaded.bind(this));

		if (this.info !== null) {
			return Promise.resolve(this.info as WorkspaceType);
		} else {
			return Promise.reject(null);
		}
	}
};

export const WorkspacePlugin = {
	install(app: any, options: any) {
		const instance = reactive(new WorkspacePluginClass());
		app.config.globalProperties.$workspace = instance;
		app.provide('$workspace', instance);
	}
};
